const floorStatics = {
  p0_w: {
    sectionPath: '/floor_0',
    locationKey: 'p0_w',
    sectionKey: 'WOMAN',
    floorKey: '0',
    section: 'p0_w.section.name',
    floor: 'p0_w.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14766_P0_1.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14766_P0.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_0',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p0_w.path.floorMap.linkName',
        title: 'p0_w.path.floorMap.title',
        info: 'p0_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P0_1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P0_1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.floorMap.description.title',
          content: 'p0_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/onlineReturn',
        exact: true,
        location: 'onlineReturn',
        linkName: 'p0_w.path.onlineReturn.linkName',
        title: 'p0_w.path.onlineReturn.title',
        info: 'p0_w.path.onlineReturn.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P0_DevolucionesOnline_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P0_DevolucionesOnline_1.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.onlineReturn.description.title',
          content: 'p0_w.path.onlineReturn.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/payAndGo',
        exact: true,
        location: 'payAndGo',
        linkName: 'p0_w.path.payAndGo.linkName',
        title: 'p0_w.path.payAndGo.title',
        info: 'p0_w.path.payAndGo.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P0_Pay&Go_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P0_Pay&Go_1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.payAndGo.description.title',
          content: 'p0_w.path.payAndGo.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/pickup',
        exact: true,
        location: 'pickup',
        linkName: 'p0_w.path.pickup.linkName',
        title: 'p0_w.path.pickup.title',
        info: 'p0_w.path.pickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P0_RecogidaRopa_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P0_RecogidaRopa_1.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.pickup.description.title',
          content: 'p0_w.path.pickup.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p0_w.path.pickUpSize.linkName',
        title: 'p0_w.path.pickUpSize.title',
        info: 'p0_w.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P0_EncuentraTalla_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P0_EncuentraTalla_1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.pickUpSize.description.title',
          content: 'p0_w.path.pickUpSize.description.content',
        },
      },
    ],
  },
  p1_w: {
    sectionPath: '/floor_1',
    locationKey: 'p1_w',
    sectionKey: 'WOMAN',
    floorKey: '1',
    section: 'p1_w.section.name',
    floor: 'p1_w.floor.name',
    title: 'Título de la Planta 1',
    img_banner:
      'https://static.zara.net/photos///2022/V/1/1/p/1381/910/001/2/w/649/1381910001_9_1_1.jpg?ts=1647001252352',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_1.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14766_P1.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_1',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p1_w.path.floorMap.linkName',
        title: 'p1_w.path.floorMap.title',
        info: 'p1_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.floorMap.description.title',
          content: 'p1_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/beauty',
        exact: true,
        location: 'beauty',
        linkName: 'p1_w.path.beauty.linkName',
        title: 'p1_w.path.beauty.title',
        info: 'p1_w.path.beauty.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_Beauty_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_Beauty_1.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.beauty.description.title',
          content: 'p1_w.path.beauty.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/shoes',
        exact: true,
        location: 'shoes',
        linkName: 'p1_w.path.shoes.linkName',
        title: 'p1_w.path.shoes.title',
        info: 'p1_w.path.shoes.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_Calzado_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_Calzado_1.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.shoes.description.title',
          content: 'p1_w.path.shoes.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/lingerie',
        exact: true,
        location: 'lingerie',
        linkName: 'p1_w.path.lingerie.linkName',
        title: 'p1_w.path.lingerie.title',
        info: 'p1_w.path.lingerie.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_Lenceria_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_Lenceria_1.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.lingerie.description.title',
          content: 'p1_w.path.lingerie.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p1_w.path.selfCheckout.linkName',
        title: 'p1_w.path.selfCheckout.title',
        info: 'p1_w.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_Autocobro_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_Autocobro_1.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.selfCheckout.description.title',
          content: 'p1_w.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/refunds',
        exact: true,
        location: 'refunds',
        linkName: 'p1_w.path.refunds.linkName',
        title: 'p1_w.path.refunds.title',
        info: 'p1_w.path.refunds.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_Devoluciones_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_Devoluciones_1.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.refunds.description.title',
          content: 'p1_w.path.refunds.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/payAndGo',
        exact: true,
        location: 'payAndGo',
        linkName: 'p1_w.path.payAndGo.linkName',
        title: 'p1_w.path.payAndGo.title',
        info: 'p1_w.path.payAndGo.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_Pay&Go_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_Pay&Go_1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.payAndGo.description.title',
          content: 'p1_w.path.payAndGo.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/onlinePickup',
        exact: true,
        location: 'onlinePickup',
        linkName: 'p1_w.path.onlinePickup.linkName',
        title: 'p1_w.path.onlinePickup.title',
        info: 'p1_w.path.onlinePickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_PuntoRecogiaOnline_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_PuntoRecogiaOnline_1.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.onlinePickup.description.title',
          content: 'p1_w.path.onlinePickup.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p1_w.path.pickUpSize.linkName',
        title: 'p1_w.path.pickUpSize.title',
        info: 'p1_w.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_EncuentraTalla_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_EncuentraTalla_1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.pickUpSize.description.title',
          content: 'p1_w.path.pickUpSize.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/fittingRooms',
        exact: true,
        location: 'fittingRooms',
        linkName: 'p1_w.path.fittingRooms.linkName',
        title: 'p1_w.path.fittingRooms.title',
        info: 'p1_w.path.fittingRooms.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_TurnoProbadores_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P1_TurnoProbadores_1.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.fittingRooms.description.title',
          content: 'p1_w.path.fittingRooms.description.content',
        },
      },
    ],
  },
  p2_m: {
    sectionPath: '/floor_2',
    locationKey: 'p2_m',
    sectionKey: 'MAN',
    floorKey: '2',
    section: 'p2_m.section.name',
    floor: 'p2_m.floor.name',
    title: 'Título de la Planta 2',
    img_banner:
      'https://static.zara.net/photos///2022/V/0/2/p/0962/428/407/33/w/649/0962428407_15_1_1.jpg?ts=1646994080095',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14766_P2_1.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14766_P2.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_2',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p2_m.path.floorMap.linkName',
        title: 'p2_m.path.floorMap.title',
        info: 'p2_m.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P2_1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P2_1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_m.path.floorMap.description.title',
          content: 'p2_m.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/athleticz',
        exact: true,
        location: 'athleticz',
        linkName: 'p2_m.path.athleticz.linkName',
        title: 'p2_m.path.athleticz.title',
        info: 'p2_m.path.athleticz.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P2_Athleticz_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P2_Athleticz_1.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p2_m.path.athleticz.description.title',
          content: 'p2_m.path.athleticz.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/shoes',
        exact: true,
        location: 'shoes',
        linkName: 'p2_m.path.shoes.linkName',
        title: 'p2_m.path.shoes.title',
        info: 'p2_m.path.shoes.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P2_Calzado_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P2_Calzado_1.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p2_m.path.shoes.description.title',
          content: 'p2_m.path.shoes.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p2_m.path.selfCheckout.linkName',
        title: 'p2_m.path.selfCheckout.title',
        info: 'p2_m.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P2_Autocobro_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P2_Autocobro_1.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p2_m.path.selfCheckout.description.title',
          content: 'p2_m.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/payAndGo',
        exact: true,
        location: 'payAndGo',
        linkName: 'p2_m.path.payAndGo.linkName',
        title: 'p2_m.path.payAndGo.title',
        info: 'p2_m.path.payAndGo.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P2_Pay&Go_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P2_Pay&Go_1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_m.path.payAndGo.description.title',
          content: 'p2_m.path.payAndGo.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p2_m.path.pickUpSize.linkName',
        title: 'p2_m.path.pickUpSize.title',
        info: 'p2_m.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P2_EncuentraTalla_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_P2_EncuentraTalla_1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_m.path.pickUpSize.description.title',
          content: 'p2_m.path.pickUpSize.description.content',
        },
      },
    ],
  },
  s1_b: {
    sectionPath: '/floor_-1',
    locationKey: 's1_b',
    sectionKey: 'KIDS',
    floorKey: '-1',
    section: 's1_b.section.name',
    floor: 's1_b.floor.name',
    title: 'Título del Sótano',
    img_banner:
      'https://static.zara.net/photos///2022/V/0/3/p/2224/766/800/303/w/649/2224766800_15_1_1.jpg?ts=1642521515572',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14766_S1_1.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14766_S1.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_-1',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 's1_b.path.floorMap.linkName',
        title: 's1_b.path.floorMap.title',
        info: 's1_b.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_S1_1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_S1_1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 's1_b.path.floorMap.description.title',
          content: 's1_b.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_-1',
        path: '/shoes',
        exact: true,
        location: 'shoes',
        linkName: 's1_b.path.shoes.linkName',
        title: 's1_b.path.shoes.title',
        info: 's1_b.path.shoes.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_S1_Calzado_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_S1_Calzado_1.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 's1_b.path.shoes.description.title',
          content: 's1_b.path.shoes.description.content',
        },
      },
      {
        sectionPath: '/floor_-1',
        path: '/payAndGo',
        exact: true,
        location: 'payAndGo',
        linkName: 's1_b.path.payAndGo.linkName',
        title: 's1_b.path.payAndGo.title',
        info: 's1_b.path.payAndGo.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_S1_Pay&Go_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_S1_Pay&Go_1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 's1_b.path.payAndGo.description.title',
          content: 's1_b.path.payAndGo.description.content',
        },
      },
      {
        sectionPath: '/floor_-1',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 's1_b.path.pickUpSize.linkName',
        title: 's1_b.path.pickUpSize.title',
        info: 's1_b.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_S1_EncuentraTalla_IMG2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14766_S1_EncuentraTalla_1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 's1_b.path.pickUpSize.description.title',
          content: 's1_b.path.pickUpSize.description.content',
        },
      },
    ],
  },
};

const StoreSuportedLanguages = [
  {
    language: 'es-ES',
    name: 'Español',
  },
  {
    language: 'gl-ES',
    name: 'Galego',
  },
  {
    language: 'eu-ES',
    name: 'Euskara',
  },
  {
    language: 'ca-ES',
    name: 'Català',
  },
  {
    language: 'en-GB',
    name: 'English',
  },
];

const HomeStatics = {
  splash:
    'https://static.zara.net/photos/contents/multichannel/maps/ZARA_LONDRES___ONC_008.jpg?ts=1631201500000',
  prehome:
    'https://static.zara.net/photos/contents/multichannel/maps/ZARA_LONDRES___ONC_015.jpg?ts=1631201500000',
  prehomeColor: '#fff',
};

const StoreConfig = {
  floorStatics,
  StoreSuportedLanguages,
  HomeStatics,
};

export default StoreConfig;
